import React from "react";
import SingleService from "./SingleService";

const UpscResourcesMain = ({ upscResources }) => {
  return (
    <div style={{ paddingBottom: "70px" }}>
      <div className="react_popular_topics pt---100 pb---70">
        <div className="container">
          <div className="row">
            {upscResources.map((freeresource) => (
              <div
                key={freeresource.id} // Always add a unique key when mapping
                className="col-lg-3 wow animate__fadeInUp"
                data-wow-duration="0.3s"
              >
                <SingleService
                  itemImg={freeresource.resourceImg}
                  title={freeresource.title}
                  resourceId={freeresource.id}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpscResourcesMain;
